import axios from 'axios';
import { getToken, setToken } from './Auth';
import { app_back_end_url_refresh_token } from "../AppConfig";

export function errorInterceptor() {
    axios.interceptors.response.use(null, async (err) => {
        const originalConfig = err.config;
        if (!err.response) {
            // network error
            console.error(err);
            return;
        }
        if (err.response.status === 400 && err.response.data.source.info !== "Invalid token") {
            //console.log("BAD_REQUEST");
            window.location.href = "/";
        }
        if (originalConfig.url !== app_back_end_url_refresh_token) {
            // Access Token was expired
            if ((err.response.status === 400 && err.response.data.source.info === "Invalid token") || err.response.status === 401) {
                try {
                    const refresh_token = (getToken()).refresh_token;
                    //console.log("refresh token")
                    const rs = await axios.post(app_back_end_url_refresh_token, { refresh_token }, {
                        headers: { 'Content-Type': 'application/json' }
                    });
                    setToken(rs.data);
                    window.location.href = "/";

                } catch (_error) {
                    //console.log(_error);
                    window.location.href = "/login";
                }
            }
        } else {
            window.location.href = "/login";
        }
    });
}